import React from "react";
import Modal from "..";
import * as S from "./checkTransportationDeleteModal.style";
import { Button } from "../../../atoms/Buttons";

type CheckTransportationDeleteModalType = {
  onDeleteModalCancelHandler: () => void;
  onModalDeleteCheckHanlder: () => Promise<void>;
  isDeleteImg: any[];
};

const CheckTransportationDeleteModal = ({
  onDeleteModalCancelHandler,
  onModalDeleteCheckHanlder,
  isDeleteImg,
}: CheckTransportationDeleteModalType) => {
  return (
    <Modal title="선택사진 삭제" titlePosition="center" size="md">
      <S.CheckTransportationDeleteModalLayout>
        <p>
          선택하신 <span>총 {isDeleteImg.length} 건</span>의 사진을
          <br />
          삭제하시겠습니까?
        </p>
        <S.ButtonBox>
          <div className="small">
            <Button
              type="button"
              size="full"
              color="transparentGray"
              label="취소"
              onClick={onDeleteModalCancelHandler}
            />
          </div>
          <Button
            type="button"
            size="full"
            color="red"
            label="삭제"
            onClick={onModalDeleteCheckHanlder}
          />
        </S.ButtonBox>
      </S.CheckTransportationDeleteModalLayout>
    </Modal>
  );
};

export default CheckTransportationDeleteModal;
